import { render, staticRenderFns } from "./tiJianJiLv.vue?vue&type=template&id=4b1efec2&scoped=true&"
import script from "./tiJianJiLv.vue?vue&type=script&lang=js&"
export * from "./tiJianJiLv.vue?vue&type=script&lang=js&"
import style0 from "./tiJianJiLv.vue?vue&type=style&index=0&id=4b1efec2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1efec2",
  null
  
)

export default component.exports